(function () {
  function parseTabs(root) {
    var script = root.querySelector('script[data-pas-tabs]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function splitKeywords(rawKeyword) {
    return (rawKeyword || '')
      .split(',')
      .map(function (keyword) { return keyword.trim(); })
      .filter(Boolean);
  }

  function textMatchesAnyKeyword(text, keywords) {
    return keywords.some(function (keyword) {
      return text.indexOf(keyword) !== -1;
    });
  }

  function applyTab(root, tabs, index) {
    var tab = tabs[index];
    if (!tab) return;

    root.querySelectorAll('[data-pas-tab-button]').forEach(function (button) {
      var isActive = Number(button.getAttribute('data-pas-tab-button')) === index;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    (tab.pas || []).forEach(function (level, levelIndex) {
      root.querySelectorAll('[data-pas-index="' + levelIndex + '"][data-field="speed-value"]').forEach(function (el) {
        el.textContent = level.speedValue || '';
      });
      root.querySelectorAll('[data-pas-index="' + levelIndex + '"][data-field="speed-bar"]').forEach(function (el) {
        el.style.width = (level.speedPercent || 0) + '%';
      });
      root.querySelectorAll('[data-pas-index="' + levelIndex + '"][data-field="range-value"]').forEach(function (el) {
        el.textContent = level.rangeValue || '';
      });
      root.querySelectorAll('[data-pas-index="' + levelIndex + '"][data-field="range-bar"]').forEach(function (el) {
        el.style.width = (level.rangePercent || 0) + '%';
      });
    });

    root.querySelectorAll('[data-field="throttle-value"]').forEach(function (el) {
      el.textContent = tab.throttleRangeValue || '';
    });
    root.querySelectorAll('[data-field="throttle-condition"]').forEach(function (el) {
      el.textContent = tab.throttleCondition || '';
    });
  }

  function findMatchingTabIndex(tabs, variantText) {
    if (!variantText) return -1;
    for (var i = 0; i < tabs.length; i++) {
      var keywords = splitKeywords(tabs[i].match);
      if (keywords.length && textMatchesAnyKeyword(variantText, keywords)) {
        return i;
      }
    }
    return -1;
  }

  function init(root) {
    var tabs = parseTabs(root);
    if (!tabs.length) return;

    root.querySelectorAll('[data-pas-tab-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        applyTab(root, tabs, Number(button.getAttribute('data-pas-tab-button')));
      });
    });

    if (root.getAttribute('data-sync-variant') === 'true') {
      document.addEventListener('variant:changed', function (event) {
        var variant = event.detail && event.detail.variant;
        if (!variant) return;
        var variantText = [variant.title, variant.option1, variant.option2, variant.option3]
          .filter(Boolean)
          .join(' ');
        var matchIndex = findMatchingTabIndex(tabs, variantText);
        if (matchIndex !== -1) applyTab(root, tabs, matchIndex);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-pas-compare]').forEach(init);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initAll)
    : initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
